import { useState } from "react";
import { FiUploadCloud } from "react-icons/fi";
import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonModal from "../../../components/modals/commonModel";
import CommonTable from "../../../components/table/table";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import { useSelector } from "react-redux";
import DefaultButton from "../../../components/buttons/defaultButton";
import DragAndDropFile from "../../../components/inputs/simpleFileUploader";
import { getSalaryReport } from "../../../../services/workspace/payroll.service";

const actions_type = {
  DOWNLOAD: "DOWNLOAD",
};

const items = [{ label: "Payroll Reports", path: "" }];

const PayrollReports = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const { limit } = useSelector((state) => state.global);
  const [openModal, setOpenModel] = useState(false);

  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    sortingUIProps,
  } = useCommonFetch(getSalaryReport, {
    dataPath: "payrollAttendance.data",
    // totalPath: "payrollAttendance.meta.total",
    errorMessage: "Failed to fetch payroll data!",
    debounceDelay: 500,

    sortingOptions: [

      { label: "Name", field: "name" }, 
      { label: "Status", field: "status" },
    ],
    sortingModule: "payrollReports",
    orderParamNames: { orderByKey: "order_by", orderTypeKey: "order_type", includeDisabledKey: "includeDisabled" },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,

    dataTransformer: (data) => {
      
      if (Array.isArray(data)) {
        const transformedData = data.map((item) => ({
          id: item.user?.uuid,
          name: {
            data: {
              name: item.user?.name ?? "Unknown",
              email: item.email ?? "",
              id: item.user?.code ?? "N/A",
              image: item.photo || null,
              link: item.uuid ? `/staff/${item.uuid}` : "#",
            },
            variant: "checkbox-profile",
          },

          calculated_salary: {
            data: item.calculated_salary,
            variant: "number",
          },
          adjustment_amount: {
            data: item.adjustment_amount,
            variant: "number",
          },
          net_salary: {
            data: item.net_salary,
            variant: "number",
          },
          status: {
            data: item.status,
            variant: "status",
          },
        }));

        const actionButton = {
          download: (item) => {
            // openModal(item, actions_type.DOWNLOAD);
          },
        };
        return { data: transformedData, action: actionButton };
      }
      return { data: [], action: {} };
    },
  });

  const TableHeaderData = [
    { label: "Staff Name", key: "name" },
    { label: "Calculated Salary", key: "calculated_salary" },
    { label: "Adjustment(+/-)", key: "adjustment_amount" },
    { label: "Net Salary", key: "net_salary" },
    { label: "Status", key: "status" },
  ];

  const handleCheckbox = (selectedRowIds) => {
    setSelectedIds(selectedRowIds);
  };

  const handleSelectedButton = (selectedRows) => {
    setOpenModel(true);
  };
  const actions = [
    {
      label: "Pay",
      icon: null,
      onClick: (selectedRows) => handleSelectedButton(selectedRows),
      color: "text-primary-800",
    },
  ];

  return (
    <div className="flex flex-col gap-2">
      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        filter={false}
        shorting
        sortingModule="payrollReports"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
      />

      <div className="bg-white">
        <CommonTable
        search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData?.data || []}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData?.action || {}}
          selectionKey="id"
          selectedRows={selectedIds}
          onSelectionChange={handleCheckbox}
          actions={actions}
        />

        {openModal && (
          <CommonModal
            modalSize="lg"
            headerTitle={"Confirm Salary Payment"}
            onClose={() => {
              setIsEditValue(null);
              setOpenModel(false);
            }}
            show={openModal}
          >
            <ConfirmSalary
              selectedRows={selectedIds}
              onClose={() => setOpenModel(false)}
              tableData={tableData}
            />
          </CommonModal>
        )}
      </div>
    </div>
  );
};

const ConfirmSalary = ({ selectedRows, onClose, tableData }) => {
  // Fix: Correct props
  const [file, setFile] = useState(null);

  // Use selectedRows to get actual data
  const staffList =
    selectedRows?.map((id) => {
      const staff = tableData?.data?.find((item) => item.id === id);
      return {
        id: staff?.name?.data?.id || "",
        name: staff?.name?.data?.name || "",
        amount: staff?.net_salary?.data || 0,
      };
    }) || [];

  const totalAmount = staffList.reduce((sum, s) => sum + s.amount, 0);

  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handlePay = () => {
    onClose?.();
  };

  return (
    <div className="flex flex-col gap-4 text-theme">
      <p className="text-cs text-dark">
        You’re about to pay salaries. Proceeding is final—
        <br />
        Are you sure? This action is irreversible.
      </p>

      <div className="border rounded-lg ">
        <table className="w-full text-sm text-left">
          <thead className="bg-light text-theme">
            <tr>
              <th className="px-4 py-2 font-semibold">Staff ID</th>
              <th className="px-4 py-2 font-semibold">Staff Name</th>
              <th className="px-4 py-2 font-semibold text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {staffList.map((staff) => (
              <tr key={staff.id} className="border-t">
                <td className="px-4 py-2">{staff.id}</td>
                <td className="px-4 py-2">{staff.name}</td>
                <td className="px-4 py-2 text-right">
                  ₹ {staff.amount.toLocaleString("en-IN")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex justify-between items-center text-base font-semibold text-theme">
        Total Amount to be Paid:{" "}
        <span className="text-xl font-bold text-theme">
          ₹ {totalAmount.toLocaleString("en-IN")}
        </span>
      </div>
      <DragAndDropFile
        label={"Upload Salary File"}
        icon={<FiUploadCloud />}
        onFileChange={handleFileChange}
        file={file}
        accept=".csv, .xlsx, .xls"
        designType="v2"
      />

      <div className="flex items-center gap-2">
        <DefaultButton
          name={"Pay"}
          onClick={() => {}}
        />
        <DefaultButton
          name={"Cancel"}
          variant="outline"
          onClick={() => {}}
        />
      </div>
    </div>
  );
};

export default PayrollReports;
